import { observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { IOperon } from 'stores/models/LacOperon';
import { selectorFromDragAndDropType } from 'utils/Visualization';
import GeneBlock from './GeneBlock';

interface IProps {
  model: IOperon;
}

class View extends Component<IProps> {
  render() {
    const { model } = this.props;
    const selector = selectorFromDragAndDropType(model);

    return (
      <Fragment>
        <div className={`operon ${selector} is-flex-centered`}>
          {model.genes.map((gene) => (
            <GeneBlock key={gene.info.label} model={gene} />
          ))}
        </div>
      </Fragment>
    );
  }
}

const OperonBlock = observer(View);
export default OperonBlock;
